import { render } from "./DistributionStatus.vue?vue&type=template&id=1de2a36a"
import script from "./DistributionStatus.vue?vue&type=script&lang=js"
export * from "./DistributionStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__